export const glyphicons = {
  properties: 'glyphicon glyphicon-list',
  delete: 'glyphicon glyphicon-trash',
  add: 'glyphicon glyphicon-plus',
  moveUp: 'glyphicon glyphicon-arrow-up',
  moveDown: 'glyphicon glyphicon-arrow-down',
  collapse: 'glyphicon glyphicon-chevron-down',
  expand: 'glyphicon glyphicon-plus', // Expand set to plus
  drag: 'glyphicon glyphicon-th',
  info: 'glyphicon glyphicon-question-sign',
  close: 'glyphicon glyphicon-remove',
  edit: 'glyphicon glyphicon-pencil',
  save: 'glyphicon glyphicon-floppy-disk'
}

export const bootstrapIcons = {
  properties: 'bi bi-card-list',
  delete: 'bi bi-trash2',
  add: 'bi bi-plus',
  moveUp: 'bi bi-arrow-up',
  moveDown: 'bi bi-arrow-down',
  collapse: 'bi bi-chevron-down',
  expand: 'bi bi-plus',
  drag: 'bi bi-grip-vertical',
  info: 'bi bi-question-circle',
  close: 'bi bi-x',
  edit: 'bi bi-pencil',
  save: 'bi bi-floppy'
}

export const fontAwesome3 = {
  properties: 'icon-list',
  delete: 'icon-trash',
  add: 'icon-plus',
  moveUp: 'icon-arrow-up',
  moveDown: 'icon-arrow-down',
  collapse: 'icon-chevron-down',
  expand: 'icon-plus',
  drag: 'icon-th',
  info: 'icon-question-sign',
  close: 'icon-remove',
  edit: 'icon-pencil',
  save: 'icon-save'
}

export const fontAwesome4 = {
  properties: 'fa fa-list',
  delete: 'fa fa-trash-o',
  add: 'fa fa-plus',
  moveUp: 'fa fa-arrow-up',
  moveDown: 'fa fa-arrow-down',
  collapse: 'fa fa-chevron-down',
  expand: 'fa fa-plus',
  drag: 'fa fa-th',
  info: 'fa fa-question-circle',
  close: 'fa fa-times',
  edit: 'fa fa-pencil',
  save: 'fa fa-floppy-o'
}

export const fontAwesome5 = {
  properties: 'fas fa-list',
  delete: 'fas fa-trash',
  add: 'fas fa-plus',
  moveUp: 'fas fa-arrow-up',
  moveDown: 'fas fa-arrow-down',
  collapse: 'fas fa-chevron-down',
  expand: 'fas fa-plus',
  drag: 'fas fa-grip-vertical',
  info: 'fas fa-question-circle',
  close: 'fas fa-times',
  edit: 'fas fa-pencil-alt',
  save: 'fas fa-save'
}

export const fontAwesome6 = {
  properties: 'fa-solid fa-list',
  delete: 'fa-solid fa-trash',
  add: 'fa-solid fa-plus',
  moveUp: 'fa-solid fa-arrow-up',
  moveDown: 'fa-solid fa-arrow-down',
  collapse: 'fa-solid fa-chevron-down',
  expand: 'fa-solid fa-plus',
  drag: 'fa-solid fa-grip-vertical',
  info: 'fa-solid fa-circle-question',
  close: 'fa-solid fa-xmark',
  edit: 'fa-solid fa-pencil',
  save: 'fa-solid fa-floppy-disk'
}
